module.exports = __webpack_public_path__ + "img/9-5.f316c223.png";